export enum IhiRecordStatusType
{
  None = "None",
  Provisional = "Provisional",
  Unverified = "Unverified",
  Verified = "Verified"
}